import styled from "styled-components";

const getSmileySize = (len) => {
  if (len > 20) {
    return "30px";
  } else if (len > 10 && len < 24) {
    return "40px";
  } else {
    return "55px";
  }
};

const getSmileySizeTab = (len) => {
  if (len > 20) {
    return "24px";
  } else if (len > 10 && len < 24) {
    return "30px";
  } else {
    return "40px";
  }
};

const getSmileySizeMob = (len) => {
  if (len > 20) {
    return "40px";
  } else if (len > 10 && len < 24) {
    return "50px";
  } else {
    return "60px";
  }
};

export const ListFaceContainer = styled.div`
  margin: ${({ config, isSmiley }) => {
    if (isSmiley) {
      return "0 auto";
    }
    return config ? "0 4%" : "0 2%";
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 52px;
  @media only screen and (max-width: 768px) {
    align-items: flex-start;
  }

  .smiley-faces-container {
    text-align: center;
    svg {
      margin-bottom: 0;
    }
  }
`;

export const ButtonImage = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin: ${({ isMoodMeterSettings }) => (isMoodMeterSettings ? "0.5em" : "0")};
  @media only screen and (max-width: 768px) {
    width: ${({ config }) => (config ? "40px" : "fit-content")};
  }
  svg {
    opacity: ${({ select, config_smileys }) =>
    !select && config_smileys ? 0.5 : 1};
    transform: ${({ select, config_smileys }) =>
    select && config_smileys ? "scale(1.1)" : "scale(1.0)"};
    height: ${({ len }) => getSmileySize(len)};
    width: ${({ len }) => getSmileySize(len)};
    @media only screen and (min-width: 768px) and (max-width: 900px) {
      height: ${({ len }) => getSmileySizeTab(len)};
      width: ${({ len }) => getSmileySizeTab(len)};
    }
    @media only screen and (max-width: 768px) {
      height: ${({ len }) => getSmileySizeMob(len)};
      width: ${({ len }) => getSmileySizeMob(len)};
    }
  }
  &:hover svg {
    transform: scale(1.1);
  }
  label {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const Title = styled.h6`
  text-align: center;
  font-weight: 700;
  margin-left: 0em;
  color: ${({ theme }) => theme.text.primary};
  font-size: 16px;
  padding: 0px 0px 10px 0px;
  margin-bottom: 0;
`;
